require("core-js/modules/es6.typed.uint8-array");

var crypto = self.crypto || self.msCrypto;

module.exports = function (bytes) {
  return crypto.getRandomValues(new Uint8Array(bytes));
};